import {Component, OnDestroy, OnInit} from '@angular/core';
import { SearchTermservice } from '../../services/search/search-service.service'
import { Router, RoutesRecognized, ActivatedRoute, Params } from '@angular/router';
import { environment } from '../../../environments/environment';
import { SharedVals } from '../../../shared/SharedVals';
import { ISubscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-locationnavtab',
  templateUrl: './locationnavtab.component.html',
  styleUrls: ['./locationnavtab.component.css']
})
export class LocationnavtabComponent implements OnInit, OnDestroy {
  public agentId: any;
  public locationId: any;
  public agentName: any;
  public agentDetails: any;
  activeTab;
  navTabs =  environment.locationTabs;
  checkListTabs = environment.locationCheckList;
  locationTabs;
  roleValue: any;
  hideFlag: boolean = false;
  subcription: ISubscription;

  constructor(private router: Router,
              private searchTermservice: SearchTermservice,
              public activatedRoute: ActivatedRoute,
              public sharedVals: SharedVals) { }

  ngOnInit() {
    this.locationId = localStorage.getItem("LocationId");
    this.agentName = localStorage.getItem("AgentName");
    this.subcription = this.sharedVals.roleValData.subscribe(data => {
      if (data == 1 || data == 4 || data == 8 || data == 16)
        this.hideFlag = true;
    }, err => {
      
      this.hideFlag = false;
    });
    /*this.roleValue = localStorage.getItem("RoleVal");
    if (this.roleValue == 1 || this.roleValue == 4 || this.roleValue == 16 || this.roleValue == 8 || this.roleValue ==32) {
      this.hideFlag = true;
    }*/

    if (this.activatedRoute.snapshot.params["docType"] !== undefined && this.activatedRoute.snapshot.params["docType"] !== '') {
      if (this.activatedRoute.snapshot.params["docType"] === 'LocationSummary')
        this.activeTab = 'Location Summary';
      else if (this.activatedRoute.snapshot.params["docType"] === 'Documents')
        this.activeTab = 'Documents';
      else if (this.activatedRoute.snapshot.params["docType"] === 'Checklist')
        this.activeTab = 'Checklist';
    }
  }

  ngOnDestroy() {
    if (this.subcription)
      this.subcription.unsubscribe();
  }

  selectedTab(tab) {
    if (tab === 'Location Summary') {
      this.activeTab = 'Location Summary';
      this.router.navigate(['agent/location', localStorage.getItem('AgentId'), 'LocationSummary', this.locationId]);
    }
    else if (tab === 'Documents') {
      this.activeTab = 'Documents';
      this.router.navigate(['agent/location', localStorage.getItem('AgentId'), 'Documents', this.locationId]);
    }
    else if (tab === 'Checklist') {
      this.activeTab = 'Checklist';
      this.router.navigate(['agent/location', localStorage.getItem('AgentId'), 'Checklist', this.locationId]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/locationnavtab/locationnavtab.component.ts